export const MAX_POLL_OPTIONS = 100;
export const VALID_MAX_VOTES_VALUE_REGEX = /^([2-9]|10)$/;
export const MAX_OPTIONS_DISPLAYED = 10;
